// Utility for filtering and sorting bookings
import { PARCEL_STATUS, PARCEL_FILTERS } from '@/constants/parcelEnums';
export function filterAndSortBookings(bookings, statusFilter, sortBy) {
  const safeBookings = Array.isArray(bookings) ? bookings : [];
  // Filter bookings by status
  let filtered = safeBookings;
  if (statusFilter === PARCEL_STATUS.ALL) {
    filtered = safeBookings;
  } else if (statusFilter === PARCEL_FILTERS.MULTI_STAGE) {
    filtered = safeBookings.filter((b) => b.isMultiStage || (b.totalLegs && b.totalLegs > 1));
  } else {
    filtered = safeBookings.filter((b) => b.status === statusFilter);
  }
  // Sort bookings
  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'type') {
      return (a.parcelType?.[0] || '').localeCompare(b.parcelType?.[0] || '');
    } else if (sortBy === 'size') {
      // crude size sort: Small < Medium < Large
      const sizeOrder = ['Small', 'Medium', 'Large'];
      const aSize = (a.parcelWeight || '').split(' ')[0];
      const bSize = (b.parcelWeight || '').split(' ')[0];
      return sizeOrder.indexOf(aSize) - sizeOrder.indexOf(bSize);
    } else {
      // time (default): most recent first
      return new Date(b.dateTime?.split('•')[0] || 0) - new Date(a.dateTime?.split('•')[0] || 0);
    }
  });
  return sorted;
}
